/** CRM OPD booking labels for appointment lists (matches Lead Insights OPD report). */

export function formatOpdBookingModeLabel(mode: string | null | undefined): string | null {
	const m = (mode ?? "").trim().toUpperCase();
	if (m === "ONLINE") return "Online";
	if (m === "OFFLINE") return "Offline";
	return null;
}

export function formatOpdConsultationTierLabel(tier: string | null | undefined): string | null {
	const t = (tier ?? "").trim().toUpperCase();
	if (t === "FREE") return "Free";
	if (t === "PAID") return "Paid";
	return null;
}

export function hasOpdBookingChannelFields(appointment: {
	opdBookingMode?: string | null;
	opdConsultationTier?: string | null;
}): boolean {
	return (
		formatOpdBookingModeLabel(appointment.opdBookingMode) != null ||
		formatOpdConsultationTierLabel(appointment.opdConsultationTier) != null
	);
}
